import { createReducer } from '@reduxjs/toolkit';

import { ModalNames } from '../../constants';
import * as actions from './actions';
import { IModalsState } from './types';

export const initialState = ModalNames.reduce(
  (acc, key) => ({
    ...acc,
    [key]: {
      isOpen: false,
    },
  }),
  {} as IModalsState,
);

export const modalsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.openModal, (state, action) => {
      const { modalName, props } = action.payload;
      state[modalName] = {
        isOpen: true,
        props,
      };
    })
    .addCase(actions.closeModal, (state, action) => {
      const { modalName } = action.payload;
      state[modalName] = {
        isOpen: false,
      };
    });
});
